import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// import Layout from "../Layout";
import { setCurrentRoute } from "../../redux/features/loginSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import useAdminHelperFunction from "../DynamicField/useAdminHelperFunction";
import { Fragment } from "react";
import { getClientThunk } from "../../redux/features/loginSlice";

function SignOutPageSSO() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [appName, setAppName] = useState({});
  const year = moment().year();
  useEffect(() => {
    dispatch(setCurrentRoute(`/ssosignout`));
    dispatch(getClientThunk());
  }, []);

  let value = useAdminHelperFunction("appName");

  useEffect(() => {
    if (Object.keys(value).length) {
      setAppName(value);
    } else {
      let appName = localStorage.getItem("AppName");
      appName = appName && appName !== "undefined" ? JSON.parse(appName) : {};
      setAppName(appName);
    }
  }, [value]);

  const [footerData, setFooterData] = useState({});
  useEffect(() => {
    setFooterData(JSON.parse(localStorage.getItem("footer")));
  }, []);

  console.log(footerData, "footer");
  return (
    <main role="main" className="main">
      <article className="sso-card shadow-1 center2">
        <div className="group">
          <div className="span5 mobile-hide no-pad no-margin">
            <div className="sso-image"></div>
          </div>
          <div className="span7 sso-content">
            <div style={{ textAlign: "center" }}>
              <div className="logo"></div>
              <div className="sso-title">
                Thank you for using{" "}
                {appName?.showField ? (
                  <Fragment>
                    <br />
                    <strong>
                      {appName?.clientSpecificLabel || appName?.defaultLabel}
                    </strong>
                  </Fragment>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="sso-content">
              You have been logged out. Please select the{" "}
              <strong>SIGN IN</strong> button below to access the site via
              Single Sign-On (SSO).
              <div style={{ margin: "0 auto" }}>
                <button
                  onClick={() => navigate("/")}
                  className="btn-primary text-center margin-top"
                >
                  SIGN IN
                </button>
              </div>
            </div>
            <div className="margin-top3">
              <footer>
                <div
                  className="container"
                  dangerouslySetInnerHTML={{
                    __html:
                      footerData?.clientSpecificLabel ||
                      footerData?.defaultLabel,
                  }}
                ></div>
              </footer>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}

export default SignOutPageSSO;
